module.exports = __webpack_public_path__ + "static/magician-03-6dd3f62b8534b8ec09a7ac2a1673a45a.png";